import { AgGridReactProps } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import {
  SizeColumnsToContentStrategy,
  SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy
} from "ag-grid-enterprise";

class AgGridService {

  getDefaultColDef = (): ColDef => {
    return {
      // allow every column to be aggregated
      enableValue: true,
      // allow every column to be grouped
      enableRowGroup: true,
      // allow every column to be pivoted
      enablePivot: true,
      // allow multiple filters to be chained
      filter: "agMultiColumnFilter",
      // hides the filter button in the column-header
      suppressHeaderFilterButton: true,
    };
  };


  getDefaultProps = ({
    hideSideBar = false,
    rowHeight = 36,
    rowGroupPanelShow = undefined,
    autoSizeStrategy = undefined,
    rowDragManaged = undefined,
    singleClickEdit = undefined,
  }: {
    hideSideBar?: boolean,
    rowHeight?: number,
    singleClickEdit?: true | undefined,
    rowDragManaged?: true | undefined,
    rowGroupPanelShow?: "always" | "never" | "onlyWhenGrouping",
    autoSizeStrategy?: (SizeColumnsToFitGridStrategy |
      SizeColumnsToFitProvidedWidthStrategy |
      SizeColumnsToContentStrategy),

  }): Partial<AgGridReactProps> => {


    // return grid props
    return {
      // --- flags
      debug: false, //  debug info to console (TODO: get it from global config)

      // hides the menu-icon (:) in column header and displays it on mouse hover
      suppressMenuHide: false,
      // hides the right-click Content Menu
      suppressContextMenu: false,

      singleClickEdit,
      rowDragManaged,
      rowHeight,
      headerHeight: 32,
      suppressFieldDotNotation: true, // allows special characters as field names
      // autoSizeStrategy,
      rowGroupPanelShow, // shows/hides the group bar at the grid top
      sideBar: hideSideBar ? false : {
        toolPanels: ['columns', 'filters'],
        defaultToolPanel: '',
      }, // shows the sidebar

    }
  }


};
export default AgGridService;